import { Project } from '@griply/assets';
import { GoalType } from '@griply/types';
import { useCreateUnlimitedGoalsAllowed } from 'features/goals';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import {
  EmptyState,
  EmptyStateVariants,
} from 'shared/components/ui/empty-state';
import { projectsHelpLink } from 'shared/constants';
import { useOpenCreateProjectDialog } from 'shared/contexts/goal-form';
import { useOpenPremiumDialog } from 'shared/contexts/premium-dialog';

export const EmptyBanner: React.FC = () => {
  const { t } = useTranslation();

  const openPremiumDialog = useOpenPremiumDialog();
  const openCreateProjectDialog = useOpenCreateProjectDialog();
  const { allowed: createProjectAllowed } = useCreateUnlimitedGoalsAllowed(
    GoalType.Project,
  );

  const onAdd = () =>
    createProjectAllowed ? openCreateProjectDialog() : openPremiumDialog();

  return (
    <EmptyState
      icon={Project}
      variant={EmptyStateVariants.Page}
      title={t('projects.empty.title')}
      description={
        <Trans
          i18nKey="pages.projects.empty.description"
          components={{
            help: (
              // eslint-disable-next-line jsx-a11y/anchor-has-content -- Trans clones this with the translated label as children
              <a
                key="help"
                href={projectsHelpLink}
                target="_blank"
                rel="noreferrer"
              />
            ),
          }}
        />
      }
    >
      <Button
        onClick={onAdd}
        size={Sizes.Medium}
        variant={Variants.Contained}
        color={Colors.Primary}
      >
        {t('general.new-project')}
      </Button>
    </EmptyState>
  );
};
